<template>
    <FormsAutocomplete 
        v-model="model"  
        :item="collection"
        :label="label"
        :clearable="clearable"
        :disabled="disabled"
        :multiple="multiple"
        :show-add="showAdd"
        :error-messages="errorMessages"
        :dense="dense"
        store-action="domainShift/ActionGetShifts"
        :filters.sync="applyFilter"
        :load-data="loadData"
        v-bind="$attrs"
    />
</template>

<script setup>

import { computed, defineEmits, defineProps } from 'vue'

//Events
const emit = defineEmits(['input', 'update:item'])

//Props
const props = defineProps({
        label: { type: String, default: 'Turno*'},
        clearable: { type: Boolean, required: false },
        disabled: { type: Boolean, required: false },
        dense: { type: Boolean, required: false },
        showAdd: { type: Boolean, required: false },
        multiple: { type: Boolean, required: false },
        value: { type: [String, Number, Object, Array] },
        item: { type: Object, required: false },
        filters: { type: Object, required: false },
        errorMessages: { type: Array, required: false },
        loadData: { type: Boolean, default: false },
        showDefault: { type: Boolean, default: false },
    })

//Computed
const model = computed({
  get: () => props.value,
  set: val => emit('input', val)
})

const collection = computed({
  get: () => props.item,
  set: val => emit('update:item', val)
})

const applyFilter = computed({
  get () {

    let filters = {}

    if(props.showDefault) {
      filters = {
        ...filters,
        filter_columns: [
          { operator: "less_equal", column: 'id', value: 3 }
        ]
      }
    }

    if (props.filters) {
      // aplicar outros filtros se necessário
      filters = {
        ...filters,
        ...props.filters,
      }
    }

    return filters
  }
})

</script>
